import React from 'react';
import { withResizeDetector } from 'react-resize-detector';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Text } from 'wix-ui-tpa/Text';
import { setTitleHashtagHeight } from '../../../actions/services/hashtagService';
import { DEFAULT_HASHTAG } from '../../../constants';
import {
  ALIGNMENT,
  HASHTAG_TITLE_OPTIONS,
} from '../../../constants/settingsConstants';

// Style
import { st, classes } from './Hashtags.st.css';
import WixService from '../../../actions/services/WixService';


const TitleHashtag = ({
  isMobile,
  height,
  setTitleHashtagHeight,
  titleHashtagHeight,
  hashtags,
  hashtagLayout,
  isDisplayHashtagsFeed,
  m_isDisplayHashtagsFeed,
  m_isDisplayTitlesHashtag,
  hashtagTitle,
  hashtagTitleText,
}) => {
  const { t } = useTranslation();

  if (typeof height === 'number' && height !== titleHashtagHeight)
    setTitleHashtagHeight(height);

  const isDisplayHashtag = isMobile
    ? m_isDisplayHashtagsFeed
    : isDisplayHashtagsFeed;
  const isDisplayTitle = isMobile
    ? m_isDisplayTitlesHashtag
    : hashtagTitle !== HASHTAG_TITLE_OPTIONS.NOTHING;
  const isCenter = hashtagLayout === ALIGNMENT.CENTER;

  if (!isDisplayHashtag || !isDisplayTitle)
    return <div id="hashtagTitle"></div>;

  return (
    <div id="hashtagTitle" className={st(classes.title, { isCenter })}>
      <Text typography="smallTitle" className={st(classes.textTitle)}>
        {hashtagTitle === HASHTAG_TITLE_OPTIONS.HASHTAGS
          ? hashtags && hashtags.length
            ? hashtags.map((hashtag) => hashtag.hashtagName + ' ')
            : WixService.isEditorX() ? t(DEFAULT_HASHTAG.hashtagNameKeyEditorX): t(DEFAULT_HASHTAG.hashtagNameKey)
          : hashtagTitleText || t('settings.text.hashtagFeedTitle')}
      </Text>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isMobile: state.appReducer.isMobile,
  hashtags: state.appReducer.hashtags,
  titleHashtagHeight: state.appReducer.titleHashtagHeight,
  hashtagLayout: state.settingsReducer.hashtagLayout,
  isDisplayHashtagsFeed: state.settingsReducer.isDisplayHashtagsFeed,
  m_isDisplayHashtagsFeed: state.settingsReducer.m_isDisplayHashtagsFeed,
  m_isDisplayTitlesHashtag: state.settingsReducer.m_isDisplayTitlesHashtag,
  hashtagTitle: state.settingsReducer.hashtagTitle,
  hashtagTitleText: state.settingsReducer.hashtagTitleText,
});

const mapDispatchToProps = (dispatch) => ({
  setTitleHashtagHeight: (height) => dispatch(setTitleHashtagHeight(height)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withResizeDetector(TitleHashtag));
